import { Axios } from './../shared/Axios';
import qs from 'qs';

class AffiliateService extends Axios {

    private static instance: AffiliateService;

    static get(): AffiliateService {
        if (!AffiliateService.instance) {
            AffiliateService.instance = new AffiliateService();
        }
        return AffiliateService.instance;
    }

    async getAffiliateConfig(data: object): Promise<any> {
        return this.instance.get(`/admin/affiliate/master${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async getAffiliateMembers(data: object): Promise<any> {
        return this.instance.get(`/admin/affiliate/member${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async getAffiliateMember(id: number): Promise<any> {
        return this.instance.get(`/admin/affiliate/member/${id}`)
    }

    async updateAffiliateMember(formData: FormData,id: number): Promise<any> {
        return this.instance.patch(`/admin/affiliate/member/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    async deleteAffiliateConfig(id: string): Promise<any> {
        return this.instance.delete(`/admin/affiliate/master/${id}`)
    }

    async updateAffiliateConfig(data: object, id: number): Promise<any> {
        return this.instance.patch(`/admin/affiliate/master/${id}`, data)
    }

    async saveAffiliateConfig(data: object): Promise<any> {
        return this.instance.post(`/admin/affiliate/master`, data)
    }

    async changeStatus(data: object): Promise<any> {
        return this.instance.patch(`/admin/affiliate/member/status`, data)
    }

    async getAffiliatePayments(data: object): Promise<any> {
        return this.instance.get(`/admin/affiliate/payment${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async generateAffiliatePayments(data: object): Promise<any> {
        return this.instance.post(`/admin/affiliate/payment/generate${qs.stringify(data, { addQueryPrefix: true })}`)
    }





}


const affiliateService = AffiliateService.get();

export { affiliateService as AffiliateService }